import { Star } from 'lucide-react';
import { useState } from 'react';

function StarRating(props) {
    const [hoveredRating, setHoveredRating] = useState(0);
    
    function ratingValueACB(e) {
        e.stopPropagation(); // förhindra att klicket bubblar upp och öppnar bokdetaljer
        const rating = hoveredRating > 0 ? hoveredRating : props.currentRating;
        props.onRate(rating);
    }

    function renderStarCB(star) {
        return (
        <Star key={star} className={`w-5 h-5 cursor-pointer ${
        (hoveredRating > 0 && hoveredRating >= star) ?
        'fill-amber-400 text-amber-400' : 
        (hoveredRating === 0 && props.currentRating >= star) ?
        'fill-amber-400 text-amber-400' : 'text-amber-200'
        }`} 
        onMouseEnter={() => setHoveredRating(star)}
        onMouseLeave={() => setHoveredRating(0)}
        onClick={ratingValueACB}
        />);
    }

    return (
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => renderStarCB(star))}
      </div>
    );
}
export default StarRating;